"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImportColumnField = exports.getImportColumnAlternativeNames = exports.getImportColumnDescription = exports.getImportColumnLabel = exports.getImportColumnKeys = void 0;
const import_1 = require("../constants/import");
const dates_1 = require("../internationalization/features/dates");
const imports_1 = require("../internationalization/features/imports");
const import_columns_1 = require("../internationalization/locales/import-columns");
const import_validator_1 = require("./import.validator");
const getImportColumnKeys = (importType, { isMembership = false } = {}) => {
    if (importType === import_validator_1.ImportType.Contact) {
        return import_1.contactImportKeys;
    }
    return isMembership ? import_1.membershipImportKeys : import_1.paymentImportKeys;
};
exports.getImportColumnKeys = getImportColumnKeys;
const DEFAULT_REGION_LABEL = (0, imports_1.getImportRegionLabel)(null);
const DEFAULT_POSTAL_CODE_LABEL = (0, imports_1.getImportPostalCodeLabel)(null);
const getImportColumnLabel = ({ key, locale, country, isMembership = false, }) => {
    const label = import_columns_1.importColumnLabels[locale][key];
    switch (key) {
        // On a payment sheet the rate is the ticket type of an event; a membership sheet has one rate per tier.
        case "rateTitle":
            return isMembership ? label : `${label} (${import_columns_1.importRateTitleEventHints[locale]})`;
        case "region": {
            const countryLabel = (0, imports_1.getImportRegionLabel)(country);
            return countryLabel === DEFAULT_REGION_LABEL ? label : countryLabel;
        }
        case "postalCode": {
            const countryLabel = (0, imports_1.getImportPostalCodeLabel)(country);
            return countryLabel === DEFAULT_POSTAL_CODE_LABEL ? label : countryLabel;
        }
        case "date":
        case "expirationDate":
            return `${label} (${(0, dates_1.getDateFormatHint)((0, dates_1.getDateFormatByCountry)(country), locale)})`;
        default:
            return label;
    }
};
exports.getImportColumnLabel = getImportColumnLabel;
const getImportColumnDescription = ({ key, locale }) => import_columns_1.importColumnDescriptions[locale][key];
exports.getImportColumnDescription = getImportColumnDescription;
// Headers Flatfile should map onto this column besides its current label, so a template an organization
// downloaded before a column was renamed still lands on the right field instead of arriving unmapped.
const getImportColumnAlternativeNames = ({ key, locale, country, isMembership = false, }) => {
    const alternativeNames = [];
    const legacyLabel = import_columns_1.importColumnLegacyLabels[locale][key];
    if (legacyLabel) {
        alternativeNames.push(legacyLabel);
    }
    // The payment label gained a qualifier, so the bare wording the template used to carry no longer matches it.
    if (key === "rateTitle" && !isMembership) {
        alternativeNames.push(import_columns_1.importColumnLabels[locale][key]);
    }
    if (key === "date" || key === "expirationDate") {
        const format = (0, dates_1.getDateFormatByCountry)(country ?? null);
        if ((0, dates_1.getDateFormatHint)(format, locale) !== format) {
            alternativeNames.push(`${import_columns_1.importColumnLabels[locale][key]} (${format})`);
        }
    }
    return alternativeNames;
};
exports.getImportColumnAlternativeNames = getImportColumnAlternativeNames;
const getImportColumnField = (key, country) => {
    switch (key) {
        case "region":
            return import_validator_1.importRegionKey;
        case "lists":
            return "list";
        case "subscriptionStatus":
            return "hasUnsubscribed";
        case "date":
            return (0, import_validator_1.getImportDateKey)(country);
        case "expirationDate":
            return (0, import_validator_1.getImportExpirationDateKey)(country);
        default:
            return key;
    }
};
exports.getImportColumnField = getImportColumnField;
